<template>
  <Layout>
    <template #header>
      <Heading>{{ $t('ppm_modal__loading_heading') }}</Heading>
    </template>

    <template #default>
      <div class="ls-main">
        <img :src="upTogetherLogo" alt="" class="ls-logo" />
        <img :src="loaderImg" alt="" class="ls-loader" />
      </div>
    </template>
  </Layout>
</template>

<script>
import Layout from '../layouts/Layout.vue'
import Heading from '../typography/Heading.vue'

export default {
  components: {
    Layout,
    Heading,
  },
  data() {
    return {
      upTogetherLogo: require('../assets/uptogether.png'),
      loaderImg: require('../assets/loader.png'),
    }
  },
}
</script>

<style scoped>
.ls-main {
  /* Base */
  @apply tw-flex tw-flex-col tw-items-center tw-mt-[72px] tw-mb-[154px] tw-gap-8;

  /* Desktop */
  @apply lg:tw-mt-[37px] lg:tw-mb-[72px];
}

.ls-logo {
  /* Base */
  @apply tw-w-[138px] tw-h-[90px];

  /* Desktop */
  @apply lg:tw-w-[195px] lg:tw-h-[127px];
}

.ls-loader {
  /* Base */
  @apply tw-w-12 tw-h-12 tw-object-contain tw-animate-spin;
}
</style>
